import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Collapse, Grid, IconButton } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import CheckboxInput from '../../Form/CheckboxInput'
import { updateUserInfo } from '../../../actions/userActions'

const Notifications = () => {
  const dispatch = useDispatch()

  const [expanded, setExpanded] = useState(false)
  const [marketingConsent, setMarketingConsent] = useState(true)

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (userInfo) {
      setMarketingConsent(userInfo.marketingConsent)
    }
  }, [userInfo, setMarketingConsent])

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const handleUpdate = () => {
    dispatch(
      updateUserInfo({
        marketingConsent,
      })
    )
  }

  return (
    <div className="p-t-40 p-b-40" style={{ borderBottom: '1px solid black' }}>
      <div className="flex space-between">
        <div className="flex">
          <div>
            <IconButton
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
              className={`m-r-10 ${expanded ? 'rotate' : ''}`}
            >
              <ChevronRight />
            </IconButton>
          </div>
          <div>
            <h4 className="m-b-0">Notifications</h4>
            <p className="m-b-0 gray-text fs14">
              Manage communications from Hexagon. You will always receive
              messages related to updates about your projects.
            </p>
          </div>
        </div>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit className="m-l-44">
        <Grid container spacing={2} className="m-t-32">
          <Grid item xs={6}>
            <CheckboxInput
              value={marketingConsent}
              setValue={setMarketingConsent}
              label={
                <div className="fs14 m-t-10 m-b-0">
                  I consent to receive marketing communications on products,
                  services, publications, and events.
                </div>
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="flex flex-end m-t-32 m-b-50">
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdate}
              >
                Update
              </Button>
            </div>
          </Grid>
        </Grid>
      </Collapse>
    </div>
  )
}

export default Notifications
